export const refundAmountValidate = (refundArray,remainingAmount) => {
    const newErrors = {}; 
        refundArray.forEach((spent, index) => {
        if (!spent.pyId) {
          newErrors[`refund.${index}.payeeId`] = "Payee Type Is Required!";
        } 
        if (!spent.amt) {
          newErrors[`refund.${index}.amount`] = "Refund Amount is Required!";
        } else if(remainingAmount < 0){
            newErrors[`refund.${index}.amount`] = "Refund amount is greater than Net payable amount!";
        }
        if (!spent.rfNo) {
          newErrors[`refund.${index}.refNo`] = "Refernce Number is Required!";
        }  
        if (!spent.pmtDt) {
          newErrors[`refund.${index}.paymentDate`] = "Payment Date is Required!";
        }  
        });
      return newErrors;
    };

    export const salesRefundValidate = (refundArray) => {
      const newErrors = {}; 
          refundArray.forEach((refund, index) => {
          if (!refund.pyId) {
            newErrors[`refund.${index}.payeeId`] = "Payee Type Is Required!";
          } 
          if (!refund.amt) {
            newErrors[`refund.${index}.amount`] = "Refund Amount is Required!";
          } 
          if (!refund.rfNo) {
            newErrors[`refund.${index}.refNo`] = "Refernce Number is Required!";
          }  
          if (!refund.pmtDt) {
            newErrors[`refund.${index}.paymentDate`] = "Payment Date is Required!";
          }  
          });
        return newErrors;
      };